export const RANGE_SELECT_WIDTH = 87;

export const COUNTRY_DD_FILTER_ID = `si-country-dropdown-download-engagement-filter`;
